const middleware = {}

middleware['authWithBackUrl'] = require('../src/middleware/authWithBackUrl.ts')
middleware['authWithBackUrl'] = middleware['authWithBackUrl'].default || middleware['authWithBackUrl']

middleware['closedSales'] = require('../src/middleware/closedSales.ts')
middleware['closedSales'] = middleware['closedSales'].default || middleware['closedSales']

middleware['featureFlags'] = require('../src/middleware/featureFlags.ts')
middleware['featureFlags'] = middleware['featureFlags'].default || middleware['featureFlags']

middleware['fired'] = require('../src/middleware/fired.ts')
middleware['fired'] = middleware['fired'].default || middleware['fired']

middleware['mainPageRedirect'] = require('../src/middleware/mainPageRedirect.ts')
middleware['mainPageRedirect'] = middleware['mainPageRedirect'].default || middleware['mainPageRedirect']

export default middleware
